import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { useLocale } from "@/locales";
import { useTitle } from "@/hooks/useTitle";
import { initAppConfigStore } from "@/logics/initAppConfig";
import "dayjs/locale/zh-cn";
import "dayjs/locale/ja";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { getAntdLocale } = useLocale();
// 初始化内部系统配置
initAppConfigStore();
// 设置页面标题
useTitle();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _unref(getAntdLocale) }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_ctx.$route.path === '/bind')
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: 0 }))
              : _createCommentVNode("", true)
          ], 1024)),
          (_ctx.$route.path !== '/bind')
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})